import { importConstants } from "../../constants/ImportConstants";

const defaultState = {
  loadingTemplate: false,
  loadingImport: false,
  error: null,
  success: false
};

export const importReducer = function (state = defaultState, action) {
  switch (action.type) {
    case importConstants.GET_TEMPLATE_REQUEST:
      return {
        ...state,
        loadingTemplate: true,
        error: null
      };
    case importConstants.GET_TEMPLATE_SUCCESS:
      return {
        ...state,
        loadingTemplate: false,
        error: null
      };
    case importConstants.GET_TEMPLATE_FAILURE:
      return {
        ...state,
        loadingTemplate: false,
        error: action.error
      };
      
    case importConstants.IMPORT_FILE_REQUEST:
      return {
        ...state,
        loadingImport: true,
        error: null,
        success: false
      };
    case importConstants.IMPORT_FILE_SUCCESS:
      return {
        ...state,
        loadingImport: false,
        error: null,
        success: true
      };
    case importConstants.IMPORT_FILE_FAILURE:
      return {
        ...state,
        loadingImport: false,
        error: action.error,
        success: false
      };
      
    case importConstants.RESET_IMPORT:
      return defaultState;
      
    default:
      return state;
  }
};